<script>
import { prepaidFormatUsedTimes, prepaidIsExpired } from '@utils/ipetbooking-prepaid'
import { orderIsCanPay } from '@utils/ipetbooking-order'
import { merchantComputed, authComputed } from '@store/helpers'
import { uniqBy, groupBy, forOwn } from 'lodash'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    OrderPaymentButton: () => import('@components/Order/OrderPaymentButton'),
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      visibleDialog: false,
      dialogDefaultValue: {},
      tempReservationAlias: '',
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    applicableEventList() {
      const applicableEvents = _cloneDeep(this.orderItem.prepaid.applicableEvents)
      const groups = groupBy(applicableEvents, 'groupId')
      const uniqueGroupList = []
      forOwn(groups, (event) => {
        let totalUsed = event.reduce((acc, cur) => acc + cur.used, 0)
        const uniqueGroup = uniqBy(event, (e) => {
          e.used = totalUsed

          return e.groupId
        })

        uniqueGroupList.push(uniqueGroup[0])
      })

      return uniqueGroupList
    },
    applicableEventGroupsList() {
      const applicableEvents = _cloneDeep(this.orderItem.prepaid.applicableEvents)
      return groupBy(applicableEvents, 'groupId')
    },
  },
  methods: {
    prepaidIsExpired,
    prepaidFormatUsedTimes,
    orderIsCanPay,
    onClickApplicableEvent(applicableEventItem) {
      const isNotCanSelectStore = () => {
        if (this.isHasReservationInCart) {
          return applicableEventItem.store.alias !== this.currentUnpaidContiner[0].orders.items[0].product.alias
        } else {
          return false
        }
      }
      this.$nextTick(() => {
        const onTryToStoreCart = (item) => {
          const loadingMaskCheckOutCart = this.$loading({
            lock: true,
            text: '前往下一步',
            spinner: `fal fa-circle-notch fa-spin`,
            background: 'rgba(81, 176, 202, 0.3)',
            customClass: 'isStyleCheckout',
          })
          this.tryToStoreCart({ reservationAlias: item.alias || applicableEventItem.alias })
            .then(() => {
              const goToReservationCheckout = () => {
                // this.$router.push({
                //   name: 'reservation-checkout',
                //   params: {
                //     storeAlias: isCanApplicableEventItem?.store?.alias || applicableEventItem.store.alias,
                //     reservationAlias: isCanApplicableEventItem?.alias || applicableEventItem.alias
                //   },
                // });
                this.$router.push({
                  name: 'add-reservation',
                  params: {
                    reservationAlias: item.alias || applicableEventItem.alias,
                  },
                })
              }

              goToReservationCheckout()
            })
            .catch((e) => {
              if (e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })
            .finally(() => {
              loadingMaskCheckOutCart.close()
            })
        }
        if (this.isBlock) {
          this.$globalDialog('DialogBlock', {})
          return
        }
        if (this.isHasReservationInCart && !!this.currentUnpaidContiner[0]?.['parent_id']) {
          this.$alert(`加購訂單尚未結帳完成，無法加入新預約`, {
            title: `提示`,
            showClose: false,
            dangerouslyUseHTMLString: true,
          }).finally(() => {})
          return false
        }
        if (this.isHasReservationInCart && isNotCanSelectStore()) {
          this.$alert(`無法預約不同分店，請重新選擇`, {
            title: `提示`,
            showClose: false,
            dangerouslyUseHTMLString: true,
          }).finally(() => {})
          return false
        }
        if (this.applicableEventGroupsList[applicableEventItem.groupId].length > 1) {
          this.$globalDialog('DialogApplicableStore', {
            applicableEventGroupsList: this.applicableEventGroupsList[applicableEventItem.groupId],
            callbackStore: (item) => {
              onTryToStoreCart(item)
            },
          })
        } else {
          onTryToStoreCart(applicableEventItem)
        }
        // const isCanApplicableEventItem = this.applicableEventGroupsList[applicableEventItem.groupId].find((reservationItem) => !!reservationItem.store.state);
      })
    },
    async tryToStoreCart({ reservationAlias }) {
      if (this.$isLoading('storeCart')) {
        return false
      }

      this.tempReservationAlias = reservationAlias

      await this.$store
        .dispatch('cart/storeCart', {
          prepaidOrderUuid: this.orderItem.id,
          inventoryAlias: '',
          params: [
            {
              alias: reservationAlias,
              qty: 1,
            },
          ],
        })
        .then(() => {
          return true
        })
    },
    /* goToReservationItemUsePrepaid(item) {
      this.$router.push({
        name: 'reservation-item',
        params: {
          reservationAlias: item.alias
        },
        query: {
          section: 'date',
          prepaidId: this.orderItem.id
        }
      })
    }, */
    goToReservationItem(item, column) {
      const { label } = column
      if (label !== '服務項目') {
        const isCanApplicableEventItem = this.applicableEventGroupsList[item.groupId].find((reservationItem) => !!reservationItem.store.state)
        this.$router.push({
          name: 'reservation-item',
          params: {
            storeAlias: isCanApplicableEventItem?.store?.alias || undefined,
            reservationAlias: isCanApplicableEventItem?.alias || item.alias,
          },
          query: {
            section: 'date',
          },
        })
      } else this.openDialogApplicableItem(item)
    },
    openDialogApplicableItem(item) {
      this.$globalDialog('DialogReservation', {
        ...item,
      })
      // this.dialogDefaultValue = {...item}
      // this.visibleDialog = true
    },
    isCanApplicableEventItem(item) {
      return this.applicableEventGroupsList[item.groupId].some((reservationItem) => !!reservationItem.store.state)
    },
  },
}
</script>
<!-- section template -->
<template>
  <div :class="$style.prepaidItemSectionItemApplicable">
    <ul :class="[$style.detailList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
      <li class="detailList__item">
        <div class="row">
          <div class="col-12">
            <div class="detailList__title">
              <span>適用項目</span>
              <span v-if="prepaidIsExpired(orderItem.expiredDate)" class="text-danger"> （{{ $t('site.PREPAID') }}已過期，無法抵扣） </span>
              <span v-else-if="orderItem.status === 2" class="text-danger"> （{{ $t('site.PREPAID') }}尚未付款） </span>
              <span v-else-if="orderItem.status === 0" class="text-danger"> （{{ $t('site.PREPAID') }}已取消，無法抵扣） </span>
            </div>
          </div>
          <div class="col-12">
            <OrderPaymentButton :order-item="orderItem" type="prepaid" button-class="mb-3" />
            <div class="tableVertical d-md-none">
              <div v-for="(item, index) in applicableEventList" :key="index" class="tableVertical__item">
                <div class="tableVertical__top">
                  {{ item.title }}
                </div>
                <ul class="tableVertical__content">
                  <li>
                    <span class="tableVertical__content__title">剩餘次數/抵用上限</span>
                    <span class="tableVertical__content__content">
                      <span :class="{ 'text-gray-2': item.times - item.used <= 0 }">
                        <span :title="item.times - item.used">{{ prepaidFormatUsedTimes(item.times - item.used) }}</span
                        >/<span :title="item.times">{{ prepaidFormatUsedTimes(item.times) }}</span>
                      </span>
                    </span>
                  </li>
                  <li>
                    <span class="tableVertical__content__title">{{ $t('site.USER') }}{{ $t('site.FORM_CATEGORY') }}</span>
                    <span class="tableVertical__content__content"> {{ item.categoryTitle }} | {{ item.sizeTitle }} </span>
                  </li>
                </ul>
                <div class="row">
                  <!--<div
                    :class="prepaidIsExpired(item.expiredDate) || item.times - item.used <= 0 ? 'col-12' : 'col-4'">
                    <BaseButton
                      class="isStylePrimary isOutline3 isRadius isSmall isFull"
                      @click="goToReservationItem(item)"
                    >
                      查看服務
                    </BaseButton>
                  </div>-->
                  <div v-if="!prepaidIsExpired(item.expiredDate) && item.times - item.used > 0 && orderItem.times - orderItem.used > 0" class="col-12">
                    <BaseButton
                      v-if="!isSiteEnabled || !currentMerchant.paymentMethods.includes('Prepaid')"
                      class="isStylePrimary isOutline3 isSmall isFull"
                      :class="{ isRadius: $globalIsJtails }"
                      disabled
                    >
                      尚未開放預約
                    </BaseButton>
                    <BaseButton
                      v-else-if="orderItem.status === 2 && !currentMerchant.prepaidSetting.canUseUnPaidPrepaid"
                      class="isStylePrimary isOutline3 isSmall isFull"
                      :class="{ isRadius: $globalIsJtails }"
                      disabled
                    >
                      尚未付款
                    </BaseButton>
                    <BaseButton v-else-if="!isCanApplicableEventItem(item)" class="isStylePrimary isOutline3 isRadius isSmall isFull" disabled @click.native.stop.prevent="''">
                      <el-popover placement="top" width="242" trigger="hover" :content="`此服務項目可使用店家暫停預約，請選擇其他方案或服務`">
                        <span slot="reference">店家暫停預約 <i slot="reference" class="fontello fontello-attention ml-1 text-gray-2"></i></span>
                      </el-popover>
                    </BaseButton>
                    <BaseButton v-else-if="item.times - item.used <= 0" class="isStylePrimary isRadius isSmall isFull" :class="{ isRadius: $globalIsJtails }" disabled> 無抵用次數 </BaseButton>
                    <BaseButton
                      v-else
                      class="isStylePrimary isOutline3 isSmall isFull"
                      :class="{ isRadius: $globalIsJtails }"
                      :loading="item.alias === tempReservationAlias && $isLoading('storeCart')"
                      :disabled="![1, 2].includes(orderItem.status)"
                      @click=";[1, 2].includes(orderItem.status) ? onClickApplicableEvent(item) : ''"
                    >
                      前往預約
                    </BaseButton>
                  </div>
                </div>
              </div>
            </div>
            <el-table
              :data="applicableEventList"
              class="isStyleBase isRowPointer d-none d-md-block"
              :class="[$style.applicableEventsTable, { isStyleDingBeauty: $globalIsDingBeauty }]"
              :style="orderItem.prepaid.description || orderItem.prepaid.notice ? 'margin-bottom: -33px;' : ''"
              @row-click="goToReservationItem"
            >
              <el-table-column v-slot="{ row }" label="服務項目">
                <span class="isTableUnderline">
                  {{ row.title }}
                </span>
              </el-table-column>

              <el-table-column v-slot="{ row }" :label="$t('site.USER')"> {{ row.categoryTitle }} | {{ row.sizeTitle }} </el-table-column>

              <el-table-column v-slot="{ row }" label="剩餘次數/抵用上限" align="center">
                <span :class="{ 'text-gray-3': row.times - row.used <= 0 }">
                  <span :title="row.times - row.used">{{ prepaidFormatUsedTimes(row.times - row.used) }}</span
                  >/<span :title="row.times">{{ prepaidFormatUsedTimes(row.times) }}</span>
                </span>
              </el-table-column>

              <el-table-column v-if="!prepaidIsExpired(orderItem.expiredDate) && orderItem.times - orderItem.used > 0" v-slot="{ row }" label="預約此項目" width="150">
                <BaseButton
                  v-if="!isSiteEnabled || !currentMerchant.paymentMethods.includes('Prepaid')"
                  class="isStylePrimary isOutline3 isSmall isFull"
                  :class="{ isRadius: $globalIsJtails }"
                  disabled
                  @click.native.stop.prevent="''"
                >
                  尚未開放預約
                </BaseButton>
                <BaseButton
                  v-else-if="orderItem.status === 2 && !currentMerchant.prepaidSetting.canUseUnPaidPrepaid"
                  class="isStylePrimary isOutline3 isSmall isFull"
                  :class="{ isRadius: $globalIsJtails }"
                  disabled
                >
                  尚未付款
                </BaseButton>
                <BaseButton v-else-if="!isCanApplicableEventItem(row)" class="isStylePrimary isOutline3 isSmall isFull" :class="{ isRadius: $globalIsJtails }" disabled @click.native.stop.prevent="''">
                  <el-popover placement="left" width="242" trigger="hover" :content="`此服務項目可使用店家暫停預約，請選擇其他方案或服務`">
                    <span slot="reference">店家暫停預約</span>
                  </el-popover>
                </BaseButton>
                <BaseButton v-else-if="row.times - row.used <= 0" class="isStylePrimary isOutline3 isSmall isFull" :class="{ isRadius: $globalIsJtails }" disabled @click.native.stop.prevent="''">
                  無剩餘次數
                </BaseButton>
                <BaseButton
                  v-else
                  :loading="row.alias === tempReservationAlias && $isLoading('storeCart')"
                  class="isStyleSecondary isSmall"
                  :class="{ isDisabled: ![1, 2].includes(orderItem.status), isRadius: $globalIsJtails }"
                  @click.native.stop.prevent=";[1, 2].includes(orderItem.status) ? onClickApplicableEvent(row) : ''"
                >
                  前往預約
                </BaseButton>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </li>
      <li v-if="!!orderItem.prepaid && !!orderItem.prepaid.description" class="detailList__item mt-4">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 方案說明 </div>
          </div>
          <div class="col-md-9" style="line-height: 2; white-space: pre-wrap" v-html="orderItem.prepaid.description"> </div>
        </div>
      </li>
      <li v-if="!!orderItem.prepaid && !!orderItem.prepaid.notice" class="detailList__item">
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title"> 注意事項 </div>
          </div>
          <div class="col-md-9" style="line-height: 2; white-space: pre-wrap" v-html="orderItem.prepaid.notice"> </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.prepaidItemSectionItemApplicable {
  :global {
    .prepaidItemSectionItemApplicable {
      @include unstyled;
    }
  }
}

.detailList {
  @include list-unstyled;

  margin: 0 0 2rem;

  :global {
    .detailList {
      &__item {
        &:not(:last-child) {
          padding-bottom: 2rem;
          border-bottom: 1px solid $color-line;
        }

        &:not(:first-child) {
          padding-top: 2rem;
        }

        &.isTitle {
          padding: 1.5rem;
          background: rgba($color-secondary, 0.1);
          border-bottom: unset;
        }
      }

      &__title {
        margin-bottom: 1.5rem;

        @extend %FontSerifWeightJtails;

        @include max-md {
          margin-bottom: 1rem;
          // color: $color-blue-dark;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .detailList {
        &__title {
          font-family: unset;
          font-weight: 400;
          color: $color-secondary;
        }
      }
    }
  }
}

.applicableEventsTable {
  :global {
    .applicableEventsTable {
      @include unstyled;
    }
  }
}
</style>
